import segmentProps from '../lib/segmentProps';

export default {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_donut_slide_viewed',
            props: {
                ...segmentProps,
                set_id: '#context.setId',
                set_name: '?#context.setName',
                secondary_visible: '#context.secondaryVisible',
                tertiary_visbile: '#context.tertiaryVisible',
                slide_number: '#context.slideNumber',
                primary_slide_template: '#context.primarySlideTemplate',
                primary_slide_purpose: '#context.primarySlidePurpose',
                secondary_copy: '#context.secondaryCopy',
                tertiary_copy: '#context.tertiaryCopy',
                slide_id: '#context.slideId',
                user_file_type: '#context.userFileType',
            },
        },
    },
};
